exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Home_input_3MJ {\n  height: 2em;\n  font-size: 2em;\n  border: 1px solid green; }\n", "", {"version":3,"sources":["/./routes/home/Home.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,wBAAwB,EAAE","file":"Home.scss","sourcesContent":[".input {\n  height: 2em;\n  font-size: 2em;\n  border: 1px solid green; }\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "Home_input_3MJ"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"modules":true,"localIdentName":"[name]_[local]_[hash:base64:3]","minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./routes/home/Home.scss
// module id = 56
// module chunks = 0